import List from '../business/accounts/list'
import Connect from 'app/redux/connect'

export default Connect(List)
